import { Component, ElementRef } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';

import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';
import { selectOptions, selectSteps } from 'src/app/shared/location-details-wizard/location-details-wizard.selectors';
import { SharedModule } from 'src/app/shared/shared.module';

import { LocationDetailsWizardActions } from './location-details-wizard.actions';
import { locationDetailsWizardFeature } from './location-details-wizard.feature';

@Component({
    selector: 'app-location-details-wizard',
    standalone: true,
    imports: [
        FreyaCommonModule,
        SharedModule,
    ],
    templateUrl: './location-details-wizard.component.html',
    styleUrl: './location-details-wizard.component.scss'
})
export class LocationDetailsWizardComponent {

    viewModel$ = this.store.select(createSelector({
        step: locationDetailsWizardFeature.selectStep,
        options: createSelector(
          selectOptions,
          locationDetailsWizardFeature.selectStep,
          locationDetailsWizardFeature.selectAnswers,
          (options, step, answers) => {
            return options.map((o) => ({
              ...o,
              selected: answers[step] === o.value,
            }))
          }
        ),
        showBackButton: createSelector(
          locationDetailsWizardFeature.selectStep,
          selectSteps,
          (currentStep, steps) => {
            if (!currentStep) return false;
            return steps.indexOf(currentStep) > 0;
          }
        ),
    }));

    actions = LocationDetailsWizardActions;

    constructor(
        public store: Store,
        public el: ElementRef,
    ) {}
}
